import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "flex items-center text-black text-lg" };
var _hoisted_2 = { class: "w-full" };
var _hoisted_3 = {
    for: "head",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_4 = ["value"];
var _hoisted_5 = { class: "w-full" };
var _hoisted_6 = {
    for: "head",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_7 = { class: "w-full" };
var _hoisted_8 = {
    for: "head",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_9 = { class: "w-full" };
var _hoisted_10 = {
    for: "body",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_11 = { class: "flex justify-between" };
import { Modal } from "flowbite-vue";
import { ref, computed, reactive } from "vue";
import { storeToRefs } from 'pinia';
import { patientStore } from '@/store/patient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MailModal',
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var alertConfirmMessage = ref(null);
        var modalType = ref("confirm");
        var showConfirm = ref(false);
        var trueBtnText = computed(function () {
            return modalType.value === "confirm" ? "OK" : "Si";
        });
        var mailTemp = reactive({ topic: '', text: '', from: '', to: '', name: '', recName: '' });
        var falseBtnText = ref("No");
        var resolvePromise;
        /*  const props = defineProps({
        reciever: String,
        recieverName: String
      })
      
      
      
          onMounted(async () => {
        mailTemp.from = patient.value.paziente_email;
        mailTemp.to = props.reciever;
        mailTemp.name = patient.value.paziente_nome + ' ' + patient.value.paziente_cognome;
        mailTemp.recName = props.recieverName;
      })*/
        function openModal(message, mail) {
            alertConfirmMessage.value = message;
            mailTemp = mail;
            showConfirm.value = true;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function handleUserInput(value) {
            if (!resolvePromise)
                return;
            resolvePromise(value);
            showConfirm.value = false;
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", null, [
                (showConfirm.value)
                    ? (_openBlock(), _createBlock(_unref(Modal), {
                        key: 0,
                        size: "2xl",
                        onClose: _cache[5] || (_cache[5] = function ($event) { return (handleUserInput(false)); })
                    }, {
                        header: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(alertConfirmMessage.value)), 1)
                        ]; }),
                        body: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('A:')), 1),
                                _createElementVNode("input", {
                                    id: "head",
                                    name: "head",
                                    value: _unref(mailTemp).to,
                                    disabled: true,
                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                }, null, 8, _hoisted_4)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Da:')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    id: "head",
                                    name: "head",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_unref(mailTemp).from) = $event); }),
                                    disabled: true,
                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                }, null, 512), [
                                    [_vModelText, _unref(mailTemp).from]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Oggetto:')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    id: "head",
                                    name: "head",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((_unref(mailTemp).topic) = $event); }),
                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                }, null, 512), [
                                    [_vModelText, _unref(mailTemp).topic]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('Testo:')), 1),
                                _withDirectives(_createElementVNode("textarea", {
                                    id: "body",
                                    name: "body",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((_unref(mailTemp).text) = $event); }),
                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                }, null, 512), [
                                    [_vModelText, _unref(mailTemp).text]
                                ])
                            ])
                        ]; }),
                        footer: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("button", {
                                    onClick: _cache[3] || (_cache[3] = function ($event) { return (handleUserInput(false)); }),
                                    type: "button",
                                    class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                                }, _toDisplayString(_ctx.$t("Annulla")), 1),
                                _createElementVNode("button", {
                                    onClick: _cache[4] || (_cache[4] = function ($event) { return (handleUserInput(true)); }),
                                    type: "button",
                                    class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                }, _toDisplayString(_ctx.$t("Inviare")), 1)
                            ])
                        ]; }),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
